import { render, staticRenderFns } from "./ListLomos.vue?vue&type=template&id=2f37e120&scoped=true"
import script from "./ListLomos.vue?vue&type=script&lang=js"
export * from "./ListLomos.vue?vue&type=script&lang=js"
import style0 from "./ListLomos.vue?vue&type=style&index=0&id=2f37e120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37e120",
  null
  
)

export default component.exports